/* eslint-disable no-case-declarations */
import {
  SET_USER_FAVORITES, USER_FAVORITES_REQUEST_FAILED, SENDING_USER_FAVORITES_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  fData: '',
  isFSending: false,
  fError: false,
  isFSuccess: false,
};

/**
  * dispatched the user data to the store
  * @param  { Object } state  default state
  * @param  { Object } action dispacthed action from middleware
  */
export default function userFavorites(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_USER_FAVORITES:
      const data = {};
      data.fData = action.fData.data;
      data.isFSending = action.isFSending;
      data.isFSuccess = action.isFSuccess;
      data.fError = action.fError;
      return { ...state, ...data };

    case SENDING_USER_FAVORITES_REQUEST:
      const sendingRequest = {};
      sendingRequest.fData = action.fData;
      sendingRequest.isFSending = action.isFSending;
      sendingRequest.isFSuccess = action.isFSuccess;
      sendingRequest.fError = action.fError;
      return { ...state, ...sendingRequest };

    case USER_FAVORITES_REQUEST_FAILED:
      const errors = {};
      errors.fData = action.fData;
      errors.isFSending = action.isFSending;
      errors.isFSuccess = action.isFSuccess;
      errors.fError = action.fError;
      errors.fMsg = action.fMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
